import React, { useRef } from 'react';
import classes from './multiSelectManage.module.scss';
import { Input, Modal } from 'antd';
import { ReactComponent as IconWarn } from '@/images/icons/edm/icon_warning-red.svg';
import { ReactComponent as IconEdit } from '@/images/icons/edm/template-group-edit.svg';
import { ReactComponent as IconDelete } from '@/images/icons/edm/template-group-delete.svg';
import { getIn18Text } from 'api';
const MultiSelectManage = ({ visible, editId, editName, dataList, editItem, saveItem, deleteItem, closeModal, onNameChange, onCancel, errorMessage, maxLength = 12, typePinyin = 'FENZU', }) => {
    const inputRef = useRef(null);
    const InputRender = (item) => {
        return (React.createElement(Input.Group, { compact: true },
            React.createElement(Input, { style: { width: '100%' }, ref: inputRef, placeholder: getIn18Text(`QINGSHURU${typePinyin}MINGCHENG`), value: editName, maxLength: maxLength, onChange: onNameChange, onClick: e => e.stopPropagation(), suffix: React.createElement(React.Fragment, null,
                    React.createElement("span", { className: classes.inputBtn, style: { marginRight: '12px' }, onClick: () => {
                            saveItem(item);
                        } }, getIn18Text('QUEDING')),
                    React.createElement("span", { className: classes.inputBtn, onClick: onCancel }, getIn18Text('QUXIAO'))) })));
    };
    const beforeDeleteItem = item => {
        Modal.confirm({
            centered: true,
            content: getIn18Text('SHIFOUQUERENSHANCHU'),
            onOk: async () => {
                deleteItem(item);
            },
        });
    };
    return (React.createElement(Modal, { title: getIn18Text(`GUANLI${typePinyin}`), footer: null, visible: visible, width: 337, onCancel: closeModal, bodyStyle: { height: '340px' }, wrapClassName: classes.groupModal },
        React.createElement("div", { className: classes.content }, dataList.length > 0 ? (dataList.map(item => {
            return (React.createElement("div", { className: editId === item.id ? classes.item1 : classes.item },
                editId === item.id ? InputRender(item) : React.createElement("span", { className: classes.itemName }, item.name),
                React.createElement("div", { className: classes.btns },
                    React.createElement(IconEdit, { className: classes.editIcon, onClick: () => {
                            editItem(item);
                            setTimeout(() => {
                                var _a;
                                (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                            }, 0);
                        } }),
                    React.createElement(IconDelete, { className: classes.deleteIcon, onClick: () => beforeDeleteItem(item) }))));
        })) : (React.createElement("div", { className: classes.notags }, getIn18Text(`ZANWU${typePinyin}`)))),
        React.createElement("div", { className: classes.err }, errorMessage && (React.createElement("div", { className: classes.errText },
            React.createElement(IconWarn, { style: { marginRight: '4px' } }),
            " ",
            errorMessage)))));
};
export default MultiSelectManage;
